import { useTranslation } from "react-i18next";
import { Message } from "primereact/message";
import { Button } from "primereact/button";


const PostState = ({ connection, state, dialogState, onClose, isEnabling, typeAccess }) => {
    const { t, i18n } = useTranslation();
    let content = null;
    if(dialogState?.nombre_servicio===t("sass.desconectar")){
        content =
            <Message
                style={{width:"100%", border:"solid #1ea97c", borderWidth:" 0 0 0 6px"}}
                severity="success" text={t("marketplace.disable_service",{service:connection.nombre_servicio})}
            />;
    }
    else if(connection?.tipo_formulario==="FEATURE"){
        let innerContent = null;
        if(connection.marketplace_servicio_id===14){
            switch (i18n.language) {
                case "es":
                    innerContent = (
                        <div className='pheno-post mb-3 mt-3'>
                            <p className='phenoPost-title'>
                                <b>Comenzar</b>
                            </p>
                            <div className='pheno-post-content'>
                                <ol className='pheno-post-ulList'>
                                    <li>Cree plantillas fenológicas en la <b>seccion Campo</b>  en el panel de <b> Configuración de Fenología </b> en Admin.</li>
                                    <li>Asigne las plantillas a sus zonas de suelo en la <b>seccion campo</b> en el panel de <b>Sectores</b>.</li>
                                    <li>Inicie la plantilla en sus zonas de suelo directamente en la herramienta de <b>análisis de suelo</b> en <a target="_blank" href="https://www.dropcontrol.com/">DropControl</a></li>
                                </ol>
                            </div>
                            <p className='phenoPost-questions'>
                                <b>Si tiene alguna pregunta adicional, por favor contacte a su agente de postventa.</b>
                            </p>
                        </div>);
                    break;
                case "fr":
                    innerContent = (
                        <div className='pheno-post mb-3 mt-3'>
                            <p className='phenoPost-title'>
                                <b>Commencer</b>
                            </p>
                            <div className='pheno-post-content'>
                                <ol className='pheno-post-ulList'>
                                    <li>Créez des modèles phénologiques dans la <b>section Champ</b> dans le panneau de <b>Configuration de la Phénologie</b> dans Admin.</li>
                                    <li>Attribuez les modèles à vos zones de sol dans la <b>section Champ</b> dans le panneau de <b>Secteurs</b>.</li>
                                    <li>Démarrez le modèle dans vos zones de sol directement dans l'outil d'<b>analyse de sol</b> sur <a target="_blank" href="https://www.dropcontrol.com/">DropControl</a></li>
                                </ol>
                            </div>
                            <p className='phenoPost-questions'>
                                <b>Si vous avez des questions supplémentaires, veuillez contacter votre agent après-vente.</b>
                            </p>
                        </div>);
                    break;
                case "it":
                    innerContent = (
                        <div className='pheno-post mb-3 mt-3'>
                            <p className='phenoPost-title'>
                                <b>Cominciare</b>
                            </p>
                            <div className='pheno-post-content'>
                                <ol className='pheno-post-ulList'>
                                    <li>Crea modelli fenologici nella <b>sezione Campo</b> nel pannello di <b>Configurazione della Fenologia</b> in Admin.</li>
                                    <li>Assegna i modelli alle tue zone di suolo nella <b>sezione Campo</b> nel pannello di <b>Settori</b>.</li>
                                    <li>Avvia il modello nelle tue zone di suolo direttamente nello strumento di <b>analisi del suolo</b> su <a target="_blank" href="https://www.dropcontrol.com/">DropControl</a></li>
                                </ol>
                            </div>
                            <p className='phenoPost-questions'>
                                <b>Se hai ulteriori domande, contatta il tuo agente di assistenza post-vendita.</b>
                            </p>
                        </div>);
                    break;
                case "tr":
                    innerContent = (
                        <div className='pheno-post mb-3 mt-3'>
                            <p className='phenoPost-title'>
                                <b>Başlamak</b>
                            </p>
                            <div className='pheno-post-content'>
                                <ol className='pheno-post-ulList'>
                                    <li>Fenoloji Ayarlarında <b>Çiftlik</b> bölümünde fenoloji <b>Ayarları</b> panelinde fenoloji şablonları oluşturun.</li>
                                    <li>Şablonları, <b>Alan</b> bölümünde <b>Sektörler</b> panelindeki toprak bölgelerinize atayın.</li>
                                    <li>Toprak analizi aracındaki <b>toprak analizi</b> aracında şablonu doğrudan toprak bölgelerinizde başlatın <a target="_blank" href="https://www.dropcontrol.com/">DropControl</a></li>
                                </ol>
                            </div>
                            <p className='phenoPost-questions'>
                                <b>Ek sorularınız varsa lütfen satış sonrası temsilcinizle iletişime geçin.</b>
                            </p>
                        </div>);
                    break;
                default:
                    innerContent = (
                        <div className="pheno-post mb-3 mt-3">
                            <p className='phenoPost-title'>
                                <b>Get Started</b>
                            </p>
                            <div className='pheno-post-content'>
                                <ol className='pheno-post-ulList'>
                                    <li>Create phenological templates in the <b>Farm section</b> in the <b>Phenology Configuration </b> panel in Admin.</li>
                                    <li>Assign the templates to your soil zones in the <b>Farm section</b> in the <b>Zones panel</b>.</li>
                                    <li>Start the template in your soil zones directly in the <b>Soil Analysis</b> tool in <a target="_blank" href="https://www.dropcontrol.com/">DropControl</a></li>
                                </ol>
                            </div>
                            <p className='phenoPost-questions'>
                                <b>If you have any further questions, please contact your Customer Care agent.</b>
                            </p>
                        </div>);
            }
        }
        content =  (<>
            <Message
                style={{width:"100%", border:"solid #1ea97c", borderWidth:" 0 0 0 6px"}}
                severity="success" text={t("marketplace.featureEnabled",{feature:connection.nombre_servicio})}
            />
            { connection?.marketplace_servicio_id===14 && innerContent}
        </>);

    }
    else if(connection?.tipo_formulario==="API_SELFMANAGED"){
        if(isEnabling){
            content =  (
                <>
                    <Message
                        style={{width:"100%", border:"solid #1ea97c", borderWidth:" 0 0 0 6px"}}
                        severity="success" text={`${connection?.nombre_servicio} - ${dialogState?.data?.nombre_compania} : ${t("marketplace.successEnabled")}`}
                    />
                </>
            );
        }else{
            content =  (
                <>
                    <Message
                        style={{width:"100%", border:"solid #1ea97c", borderWidth:" 0 0 0 6px"}}
                        severity="success" text={`
                            ${connection?.nombre_servicio} - ${dialogState?.oldData?.nombre} - ${state==="modifyTypeAccess"?t("marketplace.accessModified",{type:t(`sass.tipoUsuario.${typeAccess}`)}):t("marketplace.successModified")}`}
                    />
                </>
            );
        }
    }
    else {
        content =  (
            <>
                <Message
                    style={{width:"100%", border:"solid #1ea97c", borderWidth:" 0 0 0 6px"}}
                    severity="success" text={`${connection.nombre_servicio} ${t(isEnabling?"marketplace.successEnabled":"forms.toastSuccess")}`}
                />
                <div className='pheno-post mb-3 mt-3'>
                    <p className='phenoPost-title'>
                        {t("marketplace.enableDisclaimer")}
                    </p>
                </div>
            </>
        );
    }
    return(
        <>
            {content}
            <div className='mkt-button mkt-btn-continue mt-4'>
                <Button
                    label={t("forms.close")}
                    type='button'
                    onClick={() => onClose()}
                />
            </div>
        </>
    );
};

export default PostState;
